export const contactsData = {
    email: 'sydhamzaovais@gmail.com',
    phone: '+923014568105',
    address: 'Dysol Technologies, Lahore, Pakistan - 548000 ',

    sheetAPI: 'https://sheetdb.io/api/v1/tcz8hzyemdx0r'
}